// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M0.999512 3H13.9995V5H2.99951V15H20.9995V11H22.9995V19H0.999512V3ZM3.99951 21H19.9995V23H3.99951V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.0006 1.00195V5.58769L21.5011 4.08706L22.9154 5.50125L19.0006 9.41619L15.0838 5.49941L16.4981 4.0852L18.0006 5.58772V1.00195L20.0006 1.00195Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-install-desktop-filled')
export default class InstallDesktopFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'install-desktop-filled',
    }
  }
}
